import { getProductWithVariants, ProductWithVariants } from '@models/product';
import { MultipleDevicesWidgetComponent } from '../widgets/multiple-devices-widget/multiple-devices-widget.component';
import { defaultContractWidgets } from '@config/default-contract-widgets';

export const electronicsB2BProduct: ProductWithVariants = getProductWithVariants({
    slug: 'elektronikversicherung-gewerbe',
    title: 'Elektronikversicherung Gewerbe',
    fullTitle: 'Elektronikversicherung für Gewerbe',
    insuranceTypeName: 'Elektronikversicherung B2B',
    insuranceTypeId: 30,
    legacy: true,
    portalConfig: {
        icon: 'laptop_smartphone',
        widgets: [...defaultContractWidgets, { component: MultipleDevicesWidgetComponent }],
    },
});
